import config from 'src/common/config';

export default function fullUrl(relativeUrl) {
  if (!relativeUrl) {
    return '';
  }

  const separator = relativeUrl.startsWith('/') ? '' : '/';
  const suffix =
    !relativeUrl.includes('?') && !relativeUrl.endsWith('/') ? '/' : '';

  return `${config.absoluteUrlRoot}${separator}${relativeUrl}${suffix}`;
}
